export var UNLIMITED = undefined;
export var QueryExpType;
(function (QueryExpType) {
    QueryExpType["OR"] = "or";
    QueryExpType["AND"] = "and";
    QueryExpType["FILTER"] = "filter";
    QueryExpType["NONE"] = "none";
    QueryExpType["ALL"] = "all";
})(QueryExpType || (QueryExpType = {}));
//# sourceMappingURL=query-exp.js.map